import React from "react";
import { useNavigate } from "react-router-dom";

const ChipsSection = ({ ChipsData }) => {

    const navigate = useNavigate();
    
    const handleClick = (path) => {
        navigate(path);
    };

    return (
        <div className="container mx-auto">
            <div 
                // className="grid grid-cols-3 gap-4 mb-8 md:flex md:flex-wrap"
                className="grid grid-cols-2 gap-4 mb-8 md:grid-cols-none md:flex md:flex-wrap"

            >
                {ChipsData.map(( item, index ) => (
                    <button
                        key={item.id}
                        onClick={() => handleClick(item.redirection_end_point)}
                        className="flex items-center gap-2 px-4 py-3 text-sm font-normal rounded-md border bg-white text-gray-700 border-gray-200 hover:bg-[#4f6cbb] hover:text-white hover:shadow-sm"
                    >
                        {item.category_thumbnail_image && (
                            <img
                                src={item.category_thumbnail_image}
                                alt={item.category_name_english}
                                className="w-6 h-6"
                                loading="lazy"
                            />
                        )}
                        {item.category_name_english}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default ChipsSection;
